<template>
    <div id="loader" class="scale-up-ver-bottom center-align">
        <h3>{{message}}</h3>
        <div class="progress">
            <div class="indeterminate"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['message'],
    }
</script>

<style scoped>
    .scale-up-ver-bottom {
        -webkit-animation: scale-up-ver-bottom 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
        animation: scale-up-ver-bottom 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    }

    /* ----------------------------------------------
 * Generated by Animista on 2018-8-29 15:47:34
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

    /**
     * ----------------------------------------
     * animation scale-up-ver-bottom
     * ----------------------------------------
     */
    @-webkit-keyframes scale-up-ver-bottom {
        0% {
            -webkit-transform: scaleY(0.4);
            transform: scaleY(0.4);
            -webkit-transform-origin: 0% 100%;
            transform-origin: 0% 100%;
        }
        100% {
            -webkit-transform: scaleY(1);
            transform: scaleY(1);
            -webkit-transform-origin: 0% 100%;
            transform-origin: 0% 100%;
        }
    }

    @keyframes scale-up-ver-bottom {
        0% {
            -webkit-transform: scaleY(0.4);
            transform: scaleY(0.4);
            -webkit-transform-origin: 0% 100%;
            transform-origin: 0% 100%;
        }
        100% {
            -webkit-transform: scaleY(1);
            transform: scaleY(1);
            -webkit-transform-origin: 0% 100%;
            transform-origin: 0% 100%;
        }
    }

</style>